import { manutencao_do_retorno_de_vaga_por_municipio } from "./manutencao-do-retorno-de-vaga-por-municipio";
import { manutencao_ensino_matricula } from "./manutencao-ensino-matricula";

const parametros_por_municipio = [
  manutencao_do_retorno_de_vaga_por_municipio,
  manutencao_ensino_matricula,
];

export { parametros_por_municipio };
